// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__3wvep","title":"SectionRulesMaybe_title__2TZYp","listingPageSectionContent":"SectionRulesMaybe_listingPageSectionContent__2t7Zz"};